import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountConnectionsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  accountConnectionsFiltersInput: GraphQLTypes.AccountConnectionsFiltersInput;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
}>;

export type GetAccountConnectionsQueryResult = { __typename?: 'Query' } & {
  accountConnections?: GraphQLTypes.Maybe<
    { __typename?: 'AccountConnectionTypeConnection' } & Pick<GraphQLTypes.AccountConnectionTypeConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'AccountConnectionType' } & Pick<GraphQLTypes.AccountConnectionType, 'connectionType'> & {
                account: { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'status' | 'tradingName'> & {
                    businessUnits: Array<
                      { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'referencePrefix' | 'tradingName' | 'type'>
                    >;
                    label?: GraphQLTypes.Maybe<
                      { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>
                    >;
                  };
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetAccountConnectionsDocument = gql`
  query getAccountConnections(
    $accountId: String!
    $accountConnectionsFiltersInput: AccountConnectionsFiltersInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    accountConnections(
      accountId: $accountId
      accountConnectionsFiltersInput: $accountConnectionsFiltersInput
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      nodes {
        account {
          businessUnits {
            id
            referencePrefix
            tradingName
            type
          }
          id
          label {
            long
          }
          status
          tradingName
        }
        connectionType
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
